import { IonCol, IonRow } from '@ionic/react';
import React from 'react';
import { useIntl } from 'react-intl';
import { DqText } from '../../../dq-text';
import { JobMessages } from 'src/intl/JobMessages';
import './InformationModals.scss';
import { AppModal } from '../../../reusable-components/app-modal/AppModal';

interface SystemUsageModalProps {
  /**
   * Whether the modal is open.
   */
  isOpen: boolean;
  /**
   * Triggers the request to close the modal.
   */
  onClose: () => void;
}

export const SystemUsageModal: React.FC<SystemUsageModalProps> = ({ onClose, isOpen }) => {
  const { formatMessage } = useIntl();

  return (
    <AppModal
      isOpen={isOpen}
      title={formatMessage(JobMessages.systemUsageHeading)}
      onClose={onClose}
      primaryButton={{
        label: formatMessage(JobMessages.gotItButton),
        onClick: onClose,
      }}
    >
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.overviewHeading)}</DqText>
      </IonRow>
      <IonRow className="ion-padding-bottom">
        <DqText variant="body">{formatMessage(JobMessages.systemUsageOverviewDescription)}</DqText>
      </IonRow>
      <IonRow className="ion-color-data-blue">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.systemUsageLegendPositioning)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="ion-color-data-green">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.systemUsageLegendLanceFeeding)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="ion-color-data-orange">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.systemUsageOverviewLegendControllerOff)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="ion-color-data-yellow">
        <IonCol size="1" offset="1">
          <div className="pie-chart-graph-color-key" />
        </IonCol>
        <IonCol size="10">
          <DqText variant="body-strong">{formatMessage(JobMessages.systemUsageOverviewLegendIdle)}</DqText>
        </IonCol>
      </IonRow>
      <IonRow className="info-heading-row">
        <DqText variant="body-strong"> {formatMessage(JobMessages.insightsHeading)}</DqText>
      </IonRow>
      <ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.systemUsageInsightDescriptionOne)}</DqText>
        </li>
        <ul>
          <DqText variant="body">{formatMessage(JobMessages.systemUsageInsightDescriptionOneBullet)}</DqText>
        </ul>
        <li>
          <DqText variant="body">{formatMessage(JobMessages.systemUsageInsightDescriptionTwo)}</DqText>
        </li>
        <ul>
          <DqText variant="body">{formatMessage(JobMessages.systemUsageInsightDescriptionTwoBullet)}</DqText>
        </ul>
      </ul>
    </AppModal>
  );
};

export default SystemUsageModal;
